import { createUploadLink } from 'apollo-upload-client';
import { GRAPHQL_URI } from '../../config';

const uploadLink = createUploadLink({
  uri: GRAPHQL_URI,
});

export default uploadLink;
